import DataItemListModelBase from '../_generated/modelBases/data-item-list-model-base';

export default class DataItemListModel extends DataItemListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
